import { Action, isType } from 'ts-action'
import {
  ClearFeaturedShiftsReducer,
  FeaturedShiftsFavoriteBusiness,
  FeaturedShiftsFetching,
  FeaturedShiftsSetHasMore,
  FeaturedShiftsUnfavoriteBusiness,
  GetFeaturedShifts,
  GetFeaturedShiftsErrors,
  GetFeaturedShiftsWithoutConcat,
  UpdateFeaturedShiftApplicants,
} from 'data/upshifter/FeaturedShifts/actions'
import { IFeaturedShiftsReducer } from 'models/Shift'

const initialState: IFeaturedShiftsReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
  hasMore: false,
}

export const featuredShiftsReducer = (state = initialState, action: Action) => {
  if (isType(action, GetFeaturedShifts)) {
    const { data, meta } = action.payload
    const hasMore = meta.pagination
      ? meta.pagination.total_pages > meta.pagination.current_page
      : false
    return {
      ...state,
      meta: meta,
      data: [...state.data, ...data],
      hasMore,
      error: undefined,
    }
  }
  if (isType(action, GetFeaturedShiftsWithoutConcat)) {
    const { data, meta } = action.payload
    const hasMore = meta.pagination
      ? meta.pagination.total_pages > meta.pagination.current_page
      : false
    return {
      ...state,
      meta: meta,
      data: data,
      hasMore,
      error: undefined,
    }
  }
  if (isType(action, GetFeaturedShiftsErrors)) {
    const { payload } = action
    return {
      ...state,
      error: payload,
    }
  }
  if (isType(action, FeaturedShiftsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, FeaturedShiftsSetHasMore)) {
    const { payload } = action
    return {
      ...state,
      hasMore: payload,
    }
  }
  if (isType(action, ClearFeaturedShiftsReducer)) {
    return initialState
  }
  if (isType(action, UpdateFeaturedShiftApplicants)) {
    const { applicants, shiftId } = action.payload
    const updatedShifts = state.data.map(shift => {
      if (shift.id === shiftId) {
        const newShift = { ...shift }
        newShift.applicants.accepted_count = applicants.accepted_count
        newShift.applicants.confirmed_count = applicants.confirmed_count
        newShift.applicants.pending_count = applicants.pending_count
        return newShift
      }
      return shift
    })
    return { ...state, data: updatedShifts }
  }
  if (isType(action, FeaturedShiftsFavoriteBusiness)) {
    const { payload } = action
    const modifiedShifts = state.data.map(shift => {
      if (shift.business_id === payload.model_favored.id) {
        const modifiedShift = shift
        modifiedShift.favored = true
        modifiedShift.favorite_id = payload.id
        return modifiedShift
      }
      return shift
    })
    return {
      ...state,
      data: modifiedShifts,
    }
  }
  if (isType(action, FeaturedShiftsUnfavoriteBusiness)) {
    const { payload } = action
    const unfavoritedShifts = state.data.map(shift => {
      if (shift.business_id === payload) {
        const unfavoritedShift = shift
        unfavoritedShift.favored = false
        unfavoritedShift.favorite_id = null
        return unfavoritedShift
      }
      return shift
    })
    return {
      ...state,
      data: unfavoritedShifts,
    }
  }
  return state
}
